<template>
    <div class="relative">
        <ValidationObserver ref="form" slim>
            <form novalidate class="w-full" @submit.prevent="onSubmit">
                <div class="grid grid-cols-12 gap-5">
                    <div class="col-span-12 lg:col-span-6">
                        <ValidationProvider v-slot="{ errors }" vid="last_name" tag="div">
                            <Input
                                v-model="last_name"
                                class="w-full"
                                :placeholder="$t('common.form.last_name_placeholder')"
                                :label="$t('common.form.last_name')"
                                :error="errors"
                                :is-error-visible="isErrorVisible"
                            />
                        </ValidationProvider>
                    </div>
                    <div class="col-span-12 lg:col-span-6">
                        <ValidationProvider v-slot="{ errors }" vid="first_name" tag="div">
                            <Input
                                v-model="first_name"
                                class="w-full"
                                :placeholder="$t('common.form.first_name_placeholder')"
                                :label="$t('common.form.first_name')"
                                :error="errors"
                                :is-error-visible="isErrorVisible"
                            />
                        </ValidationProvider>
                    </div>
                    <div class="col-span-12">
                        <ValidationProvider v-slot="{ errors }" vid="email" tag="div">
                            <Input
                                v-model="email"
                                class="w-full"
                                name="email"
                                :placeholder="$t('common.form.email_placeholder')"
                                :label="$t('contact.form.email')"
                                :error="errors"
                                :is-error-visible="isErrorVisible"
                            />
                        </ValidationProvider>
                    </div>
                    <div class="col-span-12">
                        <ValidationProvider v-slot="{ errors }" vid="message" tag="div">
                            <Input
                                v-model="message"
                                class="w-full"
                                is-textarea
                                name="message"
                                :placeholder="$t('contact.form.message_placeholder')"
                                :label="$t('contact.form.message')"
                                :error="errors"
                                :is-error-visible="isErrorVisible"
                            />
                        </ValidationProvider>
                    </div>
                    <div class="col-span-12">
                        <ValidationProvider v-slot="{ errors }" vid="accept_privacy_policy" tag="div" class="mb-2">
                            <Input
                                v-model="accept_privacy_policy"
                                class="w-full"
                                is-checkbox
                                name="email"
                                :label="$t('common.form.accept_privacy_policy')"
                                :error="errors"
                                :is-error-visible="isErrorVisible"
                            />
                        </ValidationProvider>
                        <ValidationProvider v-slot="{ errors }" vid="privacy" tag="div">
                            <Input
                                v-model="accept_contact_policy"
                                class="w-full"
                                is-checkbox
                                name="email"
                                :label="$t('contact.form.accept_contact_policy')"
                                :error="errors"
                                :is-error-visible="isErrorVisible"
                            />
                        </ValidationProvider>
                    </div>
                    <div class="col-span-12">
                        <p-button
                            blue
                            type="submit"
                            :has-preloader="isLoading"
                            :label="$t('contact.form.submit')"
                            class="min-w-[7.75rem]"
                        />
                    </div>
                </div>
            </form>
        </ValidationObserver>
        <transition name="fade">
            <div
                v-if="isFeedbackMessageVisible"
                class="absolute top-0 left-0 w-full h-full bg-grey-25 rounded-md bg-opacity-100 flex items-center justify-center lg:p-8"
            >
                <div class="text-center flex flex-col justify-center items-center">
                    <i class="ri-checkbox-circle-fill text-4xl mb-2 text-green"></i>
                    <span class="mb-4 text-black text-[1.5rem] lg:text-2xl font-Inter-Bold"
                        >{{ $t('contact.form.success_title') }}</span
                    >
                    <div class="flex-col">
                        <span class="text-black block">
                            {{ $t('contact.form.success_text') }}
                        </span>
                        <span v-if="email" class="text-black block font-Inter-Bold mt-3">&nbsp;({{ email }})</span>
                    </div>
                    <div @click="hideFeedbackMessage">
                        <PButton :label="$t('common.ok')" appearance="black" class="w-max mt-8" />
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: 'ContactForm',
    props: {},
    data() {
        return {
            first_name: '',
            last_name: '',
            email: '',
            message: '',
            accept_privacy_policy: false,
            accept_contact_policy: false,
            couponError: null,
            isErrorVisible: false,
            isLoading: false,
            isFeedbackMessageVisible: false,
        };
    },
    async mounted() {
        try {
            await this.$recaptcha.init();
        } catch (e) {
            console.log(e);
        }
    },
    beforeDestroy() {
        this.$recaptcha.destroy();
    },
    methods: {
        async onSubmit() {
            this.isErrorVisible = true;
            this.isLoading = true;

            try {
                const token = await this.$recaptcha.execute('login');

                await this.$axios
                    .$post('/contact', {
                        first_name: this.first_name,
                        last_name: this.last_name,
                        email: this.email,
                        message: this.message,
                        accept_privacy_policy: this.accept_privacy_policy ? 1 : 0,
                        reCaptcha: token,
                    })
                    .then((res) => {
                        this.isLoading = false;
                        if (res.success === true) {
                            this.isFeedbackMessageVisible = true;
                        } else {
                            console.log(res.error);
                            this.$refs.form.setErrors(res.error);
                        }
                    });

                await this.$recaptcha.reset();
            } catch (err) {
                console.log(err);
            }
        },
        hideFeedbackMessage() {
            this.isFeedbackMessageVisible = false;
            this.first_name = '';
            this.last_name = '';
            this.email = '';
            this.message = '';
            this.accept_privacy_policy = false;
            this.accept_contact_policy = false;
        },
    },
};
</script>

<style scoped></style>
